import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PSL } from '../../../common/models/master-data/psl';
import { IUserSetting } from '../../../common/models/workflow/user-setting';

export const PSLActions = createActionGroup({
  source: 'PSL',
  events: {
    'Set Current PSL': props<{ psl?: PSL }>(),
    'Get Local Storage PSL': emptyProps(),
    'Get Current PSL': emptyProps(),
    'Get PSL By Session': props<{
      sessionId?: string;
      localStoragePSL?: { name: string; id: string };
    }>(),
    'Get Available PSLs': emptyProps(),
  },
});

export const PSLAPIActions = createActionGroup({
  source: 'PSL API',
  events: {
    'Get Current PSL success': props<{
      psl: PSL;
    }>(),
    'Get Current PSL failure': props<{ error: string }>(),
    'Get PSL By Session success': props<{
      psl: PSL;
    }>(),
    'Get PSL By Session failure': props<{ error: string }>(),
    'Get Available PSLs success': props<{
      psls: PSL[];
    }>(),
    'Set PSL Loading State': emptyProps(),

    'Request Failure': props<{ error: string }>(),
  },
});

export const UoMSettingActions = createActionGroup({
  source: 'UoM Setting',
  events: {
    'Load UoM Setting': emptyProps(),
    'Apply UoM Setting': props<{ uomSetting: IUserSetting }>(),
  },
});

export const UoMSettingAPIActions = createActionGroup({
  source: 'UoM Setting API',
  events: {
    'Load UoM Setting Success': props<{ uomSetting: IUserSetting }>(),
    'Apply UoM Setting Success': props<{ uomSetting: IUserSetting }>(),

    'Request Failure': props<{ error: string }>(),
  },
});
